<script>
  import BaseModal from './BaseModal.svelte';
  import Button from '../common/Button.svelte';
  
  export let isOpen = false;
  export let title = '알림';
  export let message = '';
  export let type = 'info'; // info, success, warning, error
  export let okText = '확인';
  export let onOk = () => {};

  function handleOk() {
    onOk();
    isOpen = false;
  }

  function handleClose() {
    handleOk();
  }

  $: iconMap = {
    info: 'ℹ️',
    success: '✅',
    warning: '⚠️',
    error: '❌'
  };

  $: colorMap = {
    info: 'var(--info-color)',
    success: 'var(--success-color)',
    warning: 'var(--warning-color)',
    error: 'var(--danger-color)'
  };
</script>

<BaseModal 
  bind:isOpen 
  {title}
  size="sm"
  on:close={handleClose}
  headerClass="info-modal-header"
>
  <div class="info-content">
    <div class="info-icon info-icon-{type}">
      {iconMap[type]}
    </div>
    <div class="info-message">
      {message}
    </div>
  </div>
  
  <div slot="footer" class="info-actions">
    <Button variant="primary" on:click={handleOk}>
      {okText}
    </Button>
  </div>
</BaseModal>

<style>
  .info-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: var(--spacing-lg);
  }

  .info-icon {
    font-size: 3rem;
  }

  .info-icon-info {
    color: var(--info-color);
  }

  .info-icon-success {
    color: var(--success-color);
  }

  .info-icon-warning {
    color: var(--warning-color);
  }

  .info-icon-error {
    color: var(--danger-color);
  }

  .info-message {
    font-size: var(--font-size-base);
    color: var(--text-color);
    line-height: var(--line-height-relaxed);
    text-align: center;
  }

  .info-actions {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  :global(.info-modal-header) {
    background-color: #3273dc;
    color: white;
    border-bottom: none;
  }

  :global(.info-modal-header .modal-title) {
    color: white;
  }

  :global(.info-modal-header .modal-close) {
    color: white;
    opacity: 0.8;
  }

  :global(.info-modal-header .modal-close:hover) {
    opacity: 1;
    background-color: rgba(255, 255, 255, 0.15);
  }
</style> 